module.exports = __webpack_public_path__ + "static/home-sm-014230b16bce5cab1354e7aea27f1954.png";